/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleXmarkFill: {
  name: 'circle-xmark-fill';
  data: string;
} = {
  name: 'circle-xmark-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm2.354 5.854a.5.5 0 0 0-.708-.708L8 7.293 6.354 5.646a.5.5 0 1 0-.708.708L7.293 8 5.646 9.646a.5.5 0 0 0 .708.708L8 8.707l1.646 1.647a.5.5 0 0 0 .708-.708L8.707 8l1.647-1.646Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
